import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { CustomInput, CustomSelect, Modal, NoResult, Text } from '../../..';
import { withMediaQueries } from '../../../../../app/hoc/withMediaQueries';
import { Footer, ScrollableArea } from '../../style';
import { MODAL_CLOSE } from '../../../../../app/redux/actions';
import Pagination from '../../../Pagination';
import SortBy from '../../../SortBy';
import {
  FiltersWrapper,
  Legend,
  SortingWrapper,
  ActivityCard,
  Column,
} from './style';
import {
  getFilterLabel,
  getFilterOptions,
  getSortingOptions,
} from '../../../../../utils/labels';
import Inline from '../../../Inline';
import theme from '../../../../theme';
import { ACTIVITY_LIST_GET } from '../../../../../app/redux/actions/supervisorStats';
import { timestampToDate, toPercentage } from '../../../../../utils/common';
import TimeIntervalFilter from '../../../TimeIntervalFilter';

export const ModalSupervisorActivitiesId = 'ModalSupervisorActivities';

const ModalSupervisorActivities = ({
  mediaIsPhone,
  count_activities,
  list,
  filters,
  pager,
  getActivityList,
  modalClose,
}) => {
  const scrollableAreaRef = useRef(null);

  // filters
  const [selectedFilters, setSelectedFilters] = useState({});
  const [searchValue, setSearchValue] = useState();

  useEffect(() => {
    getActivityList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleGetActivityList = (page) => {
    const parsedFilters = {
      ...selectedFilters,
      page,
    };
    getActivityList(parsedFilters);
  };

  useEffect(() => {
    if (Object.keys(selectedFilters)?.length > 0) handleGetActivityList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedFilters]);

  const onClickSearch = () => {
    setSelectedFilters({ ...selectedFilters, search_text: searchValue });
  };

  const handleOnChange = ({ key, value }) => {
    const newFilters = { ...selectedFilters };
    newFilters[key] = value?.value;
    setSelectedFilters(newFilters);
  };

  const loadMore = (page) => handleGetActivityList(page);
  const setItemsPerPage = (v) =>
    handleOnChange({ key: 'items_per_page', value: v });

  return (
    <Modal
      title="Lista attività"
      description="Sezione dedicata alla visualizzazione e al monitoraggio delle relative statistiche di tutte le attività presenti sulla piattaforma."
      modalId={ModalSupervisorActivitiesId}
      scrollableAreaRef={scrollableAreaRef}
      mbTitle={16}
      className="max-size"
    >
      <FiltersWrapper>
        <CustomInput
          size={540}
          placeholder="Cosa vuoi cercare?..."
          isSearch
          value=""
          icon="search-sm"
          isClearable
          onChange={(v) => setSearchValue(v)}
          onClickIcon={onClickSearch}
          onKeyPress={(event) => {
            if (event.key === 'Enter') onClickSearch();
          }}
        />
        {(Object.keys(filters) || []).map((key, i) => (
          <CustomSelect
            size="s"
            key={`filter-${i}`}
            wrapperId={`filter-${key}`}
            placeholder={getFilterLabel(key)}
            options={getFilterOptions(filters, key)}
            onChange={(value) => handleOnChange({ key, value })}
            isClearable
          />
        ))}
        <TimeIntervalFilter
          callback={(start_date, end_date) => {
            setSelectedFilters({
              ...selectedFilters,
              start_date,
              end_date,
            });
          }}
        />
      </FiltersWrapper>
      <SortingWrapper>
        <Text type="b3">{count_activities || 0} attività</Text>
        <SortBy
          options={getSortingOptions([
            'rate_asc',
            'rate_desc',
            'created_asc',
            'created_desc',
            'completions_asc',
            'completions_desc',
          ])}
          onChange={(v) => {
            setSelectedFilters({ ...selectedFilters, sort_by: v?.value });
          }}
        />
      </SortingWrapper>
      <Legend>
        <Text type="statistics-heading">Codice</Text>
        <Text type="statistics-heading">Nome Attività</Text>
        <Text type="statistics-heading">Area tematica</Text>
        <Text type="statistics-heading">Assegnazioni</Text>
        <Text type="statistics-heading">Fruizioni</Text>
        <Text type="statistics-heading">Completamenti</Text>
        <Text type="statistics-heading">Media punt. quiz</Text>
        {/* //? "Percorsi in cui è presente" is ko */}
        <Text type="statistics-heading">Data di creazione</Text>
      </Legend>
      <ScrollableArea ref={scrollableAreaRef} preserveShadows>
        {list?.length > 0 ? (
          (list || []).map((activity, i) => (
            <ActivityCard key={`activity-${i}`}>
              <Text type="b4" color={theme().colors.primaryDarkGray700}>
                {activity?.course_code}
              </Text>
              {/* //? "Dettaglio attività" is ko */}
              <Text type="h3" className="ellipsis">
                {activity?.activity_title}
              </Text>
              <Text type="b4" className="ellipsis">
                {activity?.category_name}
              </Text>
              <Text type="b4">{activity?.assignments || 0}</Text>
              <Column>
                <Inline alignItems="baseline">
                  <Text type="b2">{activity?.fruitions || 0}</Text>
                  <Text type="b4">/{activity?.assignments || 0}</Text>
                </Inline>
                <Text type="b5" color={theme().colors.primaryDarkGray700}>
                  {toPercentage(activity?.fruitions, activity?.assignments)}
                </Text>
              </Column>
              <Column>
                <Inline alignItems="baseline">
                  <Text type="b2">{activity?.completions || 0}</Text>
                  <Text type="b4">/{activity?.assignments || 0}</Text>
                </Inline>
                <Text type="b5" color={theme().colors.primaryDarkGray700}>
                  {toPercentage(activity?.completions, activity?.assignments)}
                </Text>
              </Column>
              <Text type="b4">
                {Math.round(activity?.average_percentage) || 0}%
              </Text>
              {/* //? "Percorsi in cui è presente" is ko */}
              <Text type="b4" color={theme().colors.primaryDarkGray700}>
                {timestampToDate(activity?.course_created, 'DD/MM/YYYY')}
              </Text>
            </ActivityCard>
          ))
        ) : (
          <NoResult />
        )}
      </ScrollableArea>
      <Footer pt={40} pb={48}>
        <Pagination
          pb={0}
          pager={pager}
          callBack={loadMore}
          setItemsPerPage={setItemsPerPage}
        />
      </Footer>
    </Modal>
  );
};

ModalSupervisorActivities.propTypes = {
  //HOC: withMediaQueries
  mediaIsPhone: PropTypes.bool,
  // state
  count_activities: PropTypes.number,
  list: PropTypes.array,
  filters: PropTypes.object,
  pager: PropTypes.object,
  // dispatch
  getActivityList: PropTypes.func.isRequired,
  modalClose: PropTypes.func.isRequired,
};

export default compose(
  connect(
    (state) => {
      const { count_activities, list, filters, pager } =
        state.supervisorStats.lists.activities;
      return { count_activities, list, filters, pager };
    },
    (dispatch) => ({
      modalClose: () => dispatch({ type: MODAL_CLOSE }),
      getActivityList: (filters) =>
        dispatch({ type: ACTIVITY_LIST_GET._REQUEST, filters }),
    })
  ),
  withMediaQueries
)(ModalSupervisorActivities);
